// Domain constants/enums for the match-payment resource (relocated from the legacy Model in wave 4.3 ahead of models/ deletion).

export const MATCH_PAYMENT_QUALIFICATION_STATE = {
  QUALIFIED: 'SYF.PaymentQualificationState.QUALIFIED',
  UNQUALIFIED: 'SYF.PaymentQualificationState.UNQUALIFIED',
  CREATED: 'SYF.PaymentQualificationState.CREATED',
} as const;

type QualificationStateMap = typeof MATCH_PAYMENT_QUALIFICATION_STATE;
type QualificationStateKey = keyof typeof MATCH_PAYMENT_QUALIFICATION_STATE;

export type MatchPaymentQualificationState = QualificationStateMap[QualificationStateKey];
